




























import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { AUDIENCE_TYPE } from '../consts';
import { useExtendAudienceTypeOptions } from '../hooks';
import { AdgroupFormData, CampaignFormData, CreateMode } from '@tt4b/ttam-enums';

const name = 'ttam-audience-type';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
  },
  props: {
    value: {
      type: Number,
      default: AUDIENCE_TYPE.NORMAL.value,
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, createMode } = toRefs(props);
    const _audienceType = computed(() => props.value);
    const { extendAudienceTypeOptions } = useExtendAudienceTypeOptions({ createMode, adgroupData, campaignData });

    const handleClick = item => {
      if (!item.disabled) {
        emit('change', item.value);
        emit('input', item.value);
      }
    };

    return {
      name,
      handleClick,
      _audienceType,
      extendAudienceTypeOptions,
    };
  },
});
